import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CursorHeart from "../../assets/heart.svg";

const Cursor = styled.div<{ $visible: boolean }>`
  position: fixed;
  width: 30px;
  height: 30px;
  pointer-events: none;
  transform: translate(-50%, -50%) rotate(5deg);
  transition:
    transform 0.1s ease-out,
    opacity 0.2s ease-in-out;
  z-index: 10000;
  background-image: url(${CursorHeart});
  background-size: contain;
  background-repeat: no-repeat;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
`;

// Tracking of mouse movement
const useCustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const moveCursor = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", moveCursor);
    return () => window.removeEventListener("mousemove", moveCursor);
  }, []);

  return { position, isHovering, setIsHovering };
};

// Cursor
export const CustomCursor = ({ isHovering }: { isHovering: boolean }) => {
  const { position } = useCustomCursor();
  const { x, y } = position;

  return (
    <Cursor style={{ left: `${x}px`, top: `${y}px` }} $visible={isHovering} />
  );
};

// The rest of styling for component
export const CustomerTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 50px 50px 0 0;
  margin-top: -40px;
  background-color: var(--mainlight);
  width: 100%;
  z-index: 2;
  position: relative;
`;

export const CustomerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 4rem 2rem 7rem 2rem;
`;

export const LpProcessP = styled.p`
  text-align: center;
  color: var(--maindark);
  font-size: 14px;
  font-weight: 500;
  width: 280px;

  @media screen and (min-width: 768px) {
    font-size: 16px;
  }
`;

export const LogoContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr); 
    gap: 10px;

   @media screen and (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr); 
        max-width: 840px;
    }

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    max-width: 1000px;
  }
`;

interface LogoBoxProps {
  $span?: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const LogoBox = styled.div<LogoBoxProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: var(--contrastlight);
  position: relative;
  height: 70px;

  @media screen and (min-width: 768px) {
    height: 80px;
  }

  @media screen and (min-width: 1024px) {
    height: 90px;
  }

  grid-column: span ${({ $span }) => $span || 1};
`;

const HoverableLogo = styled.img`
  width: 100%;
  max-height: 80px;
  padding: 18px 8px;
  object-fit: contain;
  transition: opacity 0.3s ease-in-out;
`;

// Functional Component to Handle Logo Swap
interface CustomerLogoProps {
  defaultSrc: string;
  hoverSrc: string;
  alt: string;
}

export const CustomerLogo: React.FC<CustomerLogoProps> = ({
  defaultSrc,
  hoverSrc,
  alt,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleTouchStart = () => {
    setIsHovered(true);

    setTimeout(() => {
      setIsHovered(false);
    },400);
  };

  return (
    <HoverableLogo
      src={isHovered ? hoverSrc : defaultSrc}
      alt={alt}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onTouchStart={handleTouchStart}
    />
  );
};

export const ServicesHeadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const CasesH1 = styled.h1`
  text-align: center;
  font-size: 26px;
  color: var(--maindark);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 2rem;

  @media screen and (min-width: 768px) {
    font-size: 28px;
  }

  @media screen and (min-width: 1024px) {
    font-size: 32px;
  }
`;
